import * as Sentry from "@sentry/nextjs";

/**
 * @function log Log breadcrumb to Sentry.
 * @param {string} category Category of breadcrumb.
 * @param {string} message Message to accompany breadcrumb.
 * @param {string} level Log level, defaults to "Info" - "Fatal", "Error", "Warning", "Log", "Info", "Debug", "Critical"
 * @returns void
 */
export const log = (category, message, data, level = "Info") => {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
    level: Sentry.Severity[level],
  });
};

export default {
  log,
};
